import { Link } from 'react-router-dom';

interface ThemeLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  state?: any;
}

export default function ThemeLink({
  to,
  children,
  className,
  state,
}: ThemeLinkProps) {
  return (
    <Link
      to={to}
      state={state}
      className={`font-bold text-blue hover:text-primary ${
        className ? className : ''
      }`}
    >
      {children}
    </Link>
  );
}
